module.exports = {
    // basic
    'a-role-type': 'un tipo de rol',

    // raw
    // template
};
